import React from 'react'
import { FaPlus } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type AddShapeControlProps = {
  onClick: () => void
}

const AddShapeControl = ({ onClick }: AddShapeControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClick()
  }

  return (
    <div className={cn('control', 'add-shape')} data-graph-type="control" title="Add shape">
      <a className="icon" onClick={handleClick}>
        <FaPlus aria-hidden />
        <span className="sr-only">Add shape</span>
      </a>
    </div>
  )
}

export default AddShapeControl
